import React from 'react';
import { Container } from 'reactstrap';
import Footer from './Footer';
import { NavMenu } from './NavMenu';

export function ParentLayout(props) {
 
    return (
        <div className="main_body vh-100 d-flex flex-column">
            <NavMenu />
            <Container className="flex-1">
                {props.children}
            </Container>
            <Footer />

        </div>
    );
  
}
